module.exports = "/virtual-football-league/img/amblems/left/France/Fake_Lyon.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/France/Fake_Lyon.png
// module id = 2031
// module chunks = 4